// extracted by mini-css-extract-plugin
export default {"box_wrap":"FlushingPanel_box_wrap__-h9di"};